'use client'
import Features from './Features'
import { Fragment } from 'react'
import { FEATURE_DATA } from '@/helper/DATA'
import UploadPrescriptionDrawer from '../UploadPrescriptionDrawer'
import { dispatch, useSelector } from '@/lib/store'
import { uploadPrescriptionData } from '@/lib/reducers/patientReducer'
import { updateCommonReducerData } from '@/lib/reducers/commonReducer'
import { FORM_TYPE_LAB_TEST } from '@/utils/constants'

const FeatureSection = () => {
  const patientState = useSelector((state) => state.patient) || {}
  const commonState = useSelector((state) => state.common) || {}

  const handleSelectOnClick = (type: string) => {
    switch (type) {
      case 'case2':
        return dispatch(
          updateCommonReducerData({
            ...commonState,
            requestCallbackModalIsOpen: {
              modalIsOpen: true,
              type: FORM_TYPE_LAB_TEST,
            },
          })
        )
      case 'case3':
        return dispatch(
          uploadPrescriptionData({ uploadPrescriptionModalIsOpen: true })
        )
      default:
        break
    }
  }
  return (
    <section className="bg-white">
      <div className="container max-w-full grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 items-stretch pt-6 md:pt-10 pb-6 md:pb-10 w-full">
        {FEATURE_DATA &&
          FEATURE_DATA.map((item) => {
            return (
              <Fragment key={item.id}>
                <Features
                  text={item.id}
                  title={item.title}
                  description={item.description}
                  icon={item.icon}
                  isLoginNeeded={item.isLoginNeeded}
                  onClick={() => handleSelectOnClick(item.id)}
                  backgroundColor={item.backgroundColor}
                />
              </Fragment>
            )
          })}
        <UploadPrescriptionDrawer
          open={patientState?.uploadPrescriptionModalIsOpen}
          onOpenChange={() =>
            dispatch(
              uploadPrescriptionData({ uploadPrescriptionModalIsOpen: false })
            )
          }
        />
      </div>
    </section>
  )
}

export default FeatureSection
